<template>
    <div></div>
</template>
<script>
  import { localSave } from "@/libs/util";

  export default {
    mounted(){
        //console.log('1', this.$route.params.nm);
        localSave(this.$route.params.nm, this.$route.params.prm);
        this.$router.push({ name: this.$route.params.rt });
    }
  }
</script>